import { getClarityMetadata } from '@ifixit/analytics';
import { useIFixitApiClient } from '@ifixit/ifixit-api-client';
import { useMemo } from 'react';
import type { FeedbackTransport } from './types';

const PAGE_URL_MAX_LENGTH = 255;

interface SubmittedAnswer {
   feedbackid: number;
}

export function useFeedbackApiTransport(docid?: number): FeedbackTransport {
   const client = useIFixitApiClient();

   return useMemo(
      () => ({
         async sendVote({ surface, score }) {
            const clarity = await getClarityMetadata();
            const answer = await client.post<SubmittedAnswer>(
               'feedback/prompt',
               'feedback-prompt-vote',
               {
                  body: JSON.stringify({
                     surface,
                     score,
                     docid,
                     page_url: currentPagePath(),
                     clarity_project: clarity?.projectId,
                     clarity_user: clarity?.userId,
                     clarity_session: clarity?.sessionId,
                  }),
               }
            );
            return { voteId: answer.feedbackid };
         },
         async sendText({ voteId, text }) {
            await client.post(`feedback/prompt/${voteId}/text`, 'feedback-prompt-text', {
               body: JSON.stringify({ text }),
            });
         },
      }),
      [client, docid]
   );
}

function currentPagePath(): string | undefined {
   if (typeof window === 'undefined') {
      return undefined;
   }

   return window.location.pathname.slice(0, PAGE_URL_MAX_LENGTH);
}
